var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTouchCursorPan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.86364 9h-.00139a9.06327 9.06327 0 0 0 -1.56688-3.6616c-.36107-.54315-1.59904-2.3384-2.29026-2.3384s-1.92918 1.79525-2.30053 2.34762a9.041 9.041 0 0 0 -1.56638 3.65238h-.00184l.00055.02238-.00045.00773h.00065a3.932 3.932 0 0 0 3.86289 3.96989 3.93249 3.93249 0 0 0 3.86314-3.97909h.00035l-.00025-.00406zm-3.86364 2.54167a2.50073 2.50073 0 1 1 2.44019-2.5 2.47063 2.47063 0 0 1 -2.44019 2.5z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.16931 8.6875h-1.10681v1.375l-2.0625-2.0625 2.0625-2.0625v1.375h1.46783a5.5664 5.5664 0 0 0 -.36102 1.375zm12.83069-.6875-2.0625-2.0625v1.375h-1.45776a5.476 5.476 0 0 1 .35333 1.375h1.10443v1.375z",
    opacity: 0.55
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTouchCursorPan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/touch-cursor-pan.fdb623a5120369599c235f59fc04b246.svg";